var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0833 22.9167H3.91667C2.17025 22.9167 0.75 24.3369 0.75 26.0833C0.75 27.8298 2.17025 29.25 3.91667 29.25H26.0833C27.8298 29.25 29.25 27.8298 29.25 26.0833C29.25 24.3369 27.8298 22.9167 26.0833 22.9167ZM26.0833 11.8333H3.91667C2.17025 11.8333 0.75 13.2536 0.75 15C0.75 16.7464 2.17025 18.1667 3.91667 18.1667H26.0833C27.8298 18.1667 29.25 16.7464 29.25 15C29.25 13.2536 27.8298 11.8333 26.0833 11.8333ZM26.0833 0.75H3.91667C2.17025 0.75 0.75 2.17025 0.75 3.91667C0.75 5.66308 2.17025 7.08333 3.91667 7.08333H26.0833C27.8298 7.08333 29.25 5.66308 29.25 3.91667C29.25 2.17025 27.8298 0.75 26.0833 0.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.6b2f8d2af7133b0c81df93bccf817ee0.svg";
export { ForwardRef as ReactComponent };